<template>
  <div class="color-picker" @click="openPickerHandler">
    <div :style="{ '--picker-color': color }" class="color-picker__color"></div>

    <chrome-picker :value="color" @input="updateFromPicker" v-show="openPicker" ref="colorpicker" :style="{position: 'absolute', 'z-index': '100', top: '90px'}" />

    <div class="color-picker__info">
      <label class="color-picker__label" :for="id">{{ label }}</label>
      <label class="color-picker__hex">{{ value }}</label>
    </div>
  </div>
</template>
<script>
import { v4 as uuid } from 'uuid';
// import ColourPickerInput from '@/components/admin/ColourPickerInput.vue'
import { Chrome } from 'vue-color'

export default {
  name: 'ColorPicker',
  components: {
    'chrome-picker': Chrome,
  },
  props: {
    value: String,
    label: String
  },
  mounted: function () {
    this.id = uuid();
  },
  data: function () {
    return {
      id: String,
      openPicker: false,
      lastUpdate: 0,
    };
  },
  computed: {
    color: {
      get() {
        return this.value;
      },

      set(val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    openPickerHandler: function () {
      document.addEventListener('click', this.documentClick);
      this.openPicker = true
    },
    hidePickerHandler: function () {
      document.removeEventListener('click', this.documentClick);
      this.openPicker = false
    },
    updateFromPicker(color) {
      if(Date.now() < this.lastUpdate + 400) return //fix double update event bug
      this.lastUpdate = Date.now()
      // this.color = color;
      if(color.rgba.a === 1) this.color = color.hex
      else this.color = 'rgba(' + color.rgba.r + ', ' + color.rgba.g + ', ' + color.rgba.b + ', ' + color.rgba.a + ')'
    },
    documentClick(e) {
      if(this.$el !== e.target && !this.$el.contains(e.target)) {
        this.hidePickerHandler()
      }
    }
  },
};
</script>
<style scoped lang="scss">
.color-picker {
  display: flex;
  flex-direction: row;
  border-radius: 10px;
  padding: 0;
  width: 100%;
  height: 80px;
  position: relative;
  cursor: pointer;


  &:hover {
    background: rgb(68, 68, 68);

    .color-picker__edit {
      text-decoration: underline;
    }
  }

  &__label {
    color: #fff;
  }

  &__info {
    height: 100%;
    padding: 10px 0px 10px 20px;
    box-sizing: border-box;

    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
  }

  &__hex {
    font-size: 22px;
    font-weight: bold;
    margin-top: 3px;
  }

  &__color {
    box-sizing: border-box;
    height: 100%;
    width: 80px;
    flex-shrink: 0;
    border: none;
    padding: 0;
    margin: 0;
    border-radius: 10px;
    cursor: pointer;
    background-color: var(--picker-color);
    border-radius: 50%;
    border: 2px solid $grey-3;
  }

  &__input {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
  }
}
</style>

<style lang="scss">
.vc-chrome-alpha-wrap {
  display: none;
}
</style>
